var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main pa-8",staticStyle:{"min-height":"550px"}},[(_vm.nofund)?_c('NoData'):_vm._e(),(!_vm.nofund)?_c('router-view'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }